import LiveEffect from './LiveEffect.js';
import {
    setEffectParameterValues,
    setSelectedPalette,
    setSequencedPalette
} from 'actions/index.js';
import {isNumber} from 'utils/IsNumber.js';
import ParameterContext from 'effects/ParameterContext.js';
import {PALETTE_EFFECT} from './constants.js';

class PaletteEffect extends LiveEffect {
    constructor(track) {
        super('Palettes', PALETTE_EFFECT, track);

        // keeps track of the list of palettes (which
        // are just ids that can be referenced)
        this.palettes = [0,1];
    }

    newPalette() {
        this.palettes = [... this.palettes, this.palettes.length];
    }

    get selectedPalette() {
        return this.track.sequencerEngine.state.effects.selectedPalettes[this.track.id];
    }

    get sequencedPalette() {
        return this.track.sequencerEngine.state.effects.sequencedPalettes[this.track.id];
    }

    switchToPalette(p, oldPalette=this.sequencedPalette, time, select=false) {
        let bulkUpdate = {};
        p = p === null ? undefined : p;
        if (select) {
            this.track.store.dispatch(setSelectedPalette(this.track.id, p));
        }
        this.track.store.dispatch(setSequencedPalette(this.track.id, p));

        // todo: make new redux action for setSequencedPalette(track)
        let parameters = this.track.getAllParameters()
            .filter(param =>
                    (p === undefined && param.paletteToValue[oldPalette] !== undefined) ||
                    (oldPalette === undefined && param.paletteToValue[p] !== undefined) ||
                    param.paletteToValue[p] !== param.paletteToValue[oldPalette]);

        for (let param of parameters) {
            let update = param.set(param.getPaletteValue(p), true, true, time);
            if (update) {
                bulkUpdate[update.id] = update.value;
            }
        }
        //if (!this.track.sequencerEngine.playing) {
            // only update redux when NOT-playing. This is because
            // its way too much of a cpu load for it to update the UI
            // while playing
            this.track.store.dispatch(setEffectParameterValues(bulkUpdate));
       // }
    }

    getJson() {
        return {
            ... super.getJson(),
            palettes: this.palettes
        };
    }

    fromJson(json) {
        super.fromJson(json);
        this.palettes = json.palettes;
    }

    getCopy(track=this.track) {
        let copied = new PaletteEffect(track);
        copied.fromJson(this.getJson());
        return copied;
    }
}

export default PaletteEffect;

 
